import { Box } from '@mui/material'
import React from 'react'
import { VariantModelData } from '../../shared/utils/interfaces/VariantModelResponse'
import dynamic from 'next/dynamic'
import CustomModelViewerUIElements from '../CustomModelViewerUIElements/CustomModelViewerUIElements'

interface CustomModelViewerViewProps {
  selectedVariantModel: VariantModelData,
  single?: boolean
}

const DynamicComponentWithNoSSR = dynamic(
  () => import('../CustomModelViewer/CustomModelViewer'),
  {
    ssr: false,
    loading: () => <div style={{ height: "100%", width: "100%", position: "relative", minHeight: "730px" }}></div>
  }
)

const CustomModelViewerView = (props: CustomModelViewerViewProps) => {
  return (
    <Box style={{ height: "100%", width: "100%", position: "relative" }}>
      <DynamicComponentWithNoSSR selectedVariantModel={props.selectedVariantModel} />
      <CustomModelViewerUIElements single={props.single} selectedVariantModel={props.selectedVariantModel} />
    </Box>
  )
}

export default CustomModelViewerView